import { VersionableId } from '../../../../types/versionableId';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { selectSelectedSchemaName } from '../../../../store/schemas/schemasSelector';
import SmscDeleteDialog from '../../components/smsc/SmscDeleteDialog';
import { fetchSchemaByName } from '../../../../store/schemas/schemasActions';
import SmscApi from '../../../../api/smscApi';
import { AppErrorList, useAppErrorList } from '../../../../shared/components/AppErrorList';

type Props = {
  readonly isOpen: boolean;
  readonly smscId?: VersionableId;
  readonly hideSmscDeleteDialog: () => void;
};

const SmscDeleteDialogContainer = (props: Props) => {
  const {
    isOpen,
    smscId,
    hideSmscDeleteDialog,
  } = props;

  const dispatch = useAppDispatch();
  const [{ errors, hasErrors }, { addError, removeError }] = useAppErrorList();
  const selectedSchemaName = useAppSelector(selectSelectedSchemaName);

  const handleDeleteSmsc = () => {
    if (selectedSchemaName && smscId) {
      const smscName = smscId.resourceName;

      SmscApi.deleteSmsc(selectedSchemaName, smscName)
        .then(() => {
          dispatch(fetchSchemaByName(selectedSchemaName));
          hideSmscDeleteDialog();
        })
        .catch(addError);
    }
  };

  return (
    <>
      { hasErrors && (
        <AppErrorList
          errors={errors}
          onCloseError={removeError}
        />
      )}

      <SmscDeleteDialog
        isOpen={isOpen}
        smscId={smscId}
        onConfirmClick={handleDeleteSmsc}
        onCancelClick={hideSmscDeleteDialog}
      />
    </>
  );
};

export default SmscDeleteDialogContainer;
